import { render } from "./ChannelSelectModal.vue?vue&type=template&id=ab9772f8"
import script from "./ChannelSelectModal.vue?vue&type=script&lang=js"
export * from "./ChannelSelectModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__